import React, { useEffect, useState } from 'react';
import { Field, Input, Stack, Text } from '@chakra-ui/react';
import AuthDialog from '../ui/AuthDialog';
import { FormActions, PrimaryButton, SecondaryButton } from '../ui/FormActions';

function ChangePasswordModal({ open, onClose, onSubmit, lang }) {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [submitError, setSubmitError] = useState('');

  const isEn = lang === 'en';

  useEffect(() => {
    if (open) {
      setSubmitError('');
    }
  }, [open]);

  return (
    <AuthDialog
      open={open}
      onClose={onClose}
      title={isEn ? 'Change password' : '修改密码'}
      description={
        isEn
          ? 'Set a new, more secure password for your account. You will need to log in again after updating it.'
          : '为你的账号设置一个更安全的新密码。更新后需要重新登录。'
      }
    >
      {submitError ? (
        <Text fontSize="sm" color="red.500" mb={3}>
          {submitError}
        </Text>
      ) : null}
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          setSubmitError('');
          try {
            await onSubmit({ oldPassword, newPassword });
          } catch (err) {
            setSubmitError(err?.message || (isEn ? 'Update failed' : '修改失败'));
          }
        }}
      >
        <Stack gap={3} width="100%" minW={0}>
          <Field.Root required width="100%">
            <Input
              type="password"
              width="100%"
              maxW="100%"
              boxSizing="border-box"
              value={oldPassword}
              onChange={(e) => {
                setOldPassword(e.target.value);
                if (submitError) setSubmitError('');
              }}
              placeholder={isEn ? 'Current password' : '旧密码'}
              borderRadius="lg"
              bg={{ base: 'white', _dark: 'gray.900' }}
            />
          </Field.Root>
          <Field.Root required width="100%">
            <Input
              type="password"
              width="100%"
              maxW="100%"
              boxSizing="border-box"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                if (submitError) setSubmitError('');
              }}
              placeholder={isEn ? 'New password (at least 8 characters)' : '新密码（至少8位）'}
              minLength={8}
              borderRadius="lg"
              bg={{ base: 'white', _dark: 'gray.900' }}
            />
          </Field.Root>
        </Stack>
        <FormActions>
          <PrimaryButton>{isEn ? 'Submit' : '提交'}</PrimaryButton>
          <SecondaryButton onClick={onClose}>{isEn ? 'Close' : '关闭'}</SecondaryButton>
        </FormActions>
      </form>
    </AuthDialog>
  );
}

export default ChangePasswordModal;
